




































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { IRules } from '../UI/Form/ValidationModule';
import { validateRequired } from '../UI/Form/Validations';
import PermissionService from '@/utils/permission-service';
import DeepCopy from '@/decorators/deep-copy';

@Component
export default class DepartmentForm extends Vue {
  public PermissionService = PermissionService;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @DeepCopy('data') private formData!: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public data!: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public query!: any;

  public validForm = true;
  public rules: IRules = {
    code: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: this.t_attr('Department', 'code') }),
    } ],
    name: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: this.t_attr('Department', 'name') }),
    } ],
  };

  @Emit()
  public mutationDone() {}
}
